import React from 'react'
import { Alert } from 'reactstrap'
import styled from 'styled-components'

import { FCompanyBranchStatusFragment } from '../../graph/generated'
import { useShopStatus } from '../../hooks/useShopStatus'
import { i18n } from '../../i18n'

interface IProps {
  status: FCompanyBranchStatusFragment
}

const StyledShopCloseAlert = styled(Alert)`
  background: ${({ theme }) => theme.primary};
  color: white;
  text-align: center;
  border-radius: 0.7rem;
  position: fixed;
  top: 0.1rem;
  z-index: 3;
  padding: 0.4rem 1rem;
`

export const ShopCloseAlert: React.FC<IProps> = ({ status }) => {
  const { decision, closingIn } = useShopStatus({
    status,
  })
  if (decision === 'ClosingSoon') {
    const closingInPlural = i18n.plural({
      value: closingIn,
      one: 'closing in 1 minute',
      few: 'closing in # minutes',
      other: 'closing in # minutes',
    })
    return (
      <StyledShopCloseAlert>
        {i18n.t`Beware! We are ${closingInPlural}. Finish your order quickly.`}
      </StyledShopCloseAlert>
    )
  }
  return null
}
